import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1931c792")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("a", {
    class: "icon",
    target: "_blank",
    rel: "noopener noreferrer",
    href: _ctx.url
  }, [
    _createVNode("i", { class: _ctx.faIcon }, null, 2)
  ], 8, ["href"]))
})